import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import Common from "../../../helper/common";
import {
  FormikInput,
  FormikSwitch,
  FormikSelect,
  PhoneInputField,
  FormikSearchSelect,
  FormikDate,
  FormikSingleWithMultiUploadInAPage,
} from "../../../components/formik-components";
import { Button } from "../../../components/ui/button";
import { Card, CardContent } from "../../../components/ui/card";
import { ImageFolderEnum, respEnum } from "../../../constants/appConstant";
import ChangePassword from "../editpassword";
import common from "../../../helper/common";
const formValidations = yup.object({
  firstName: yup.string().required("First Name is Required"),
  lastName: yup.string().required("Last Name is Required"),
});
const formInitialValues = {
  changePassword: false,
};

export default function UpdateProfile() {
  const navigate = useNavigate();
  const formikRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [showPasswordDialog, setShowPasswordDialog] = useState(false);
  const [State, setState] = useState([]);
  const [Country, setCountry] = useState([]);
  const [City, setCity] = useState([]);
  const [image, setImage] = useState(null);

  useEffect(() => {
    GetUserProfile();
    getCountries();
  }, []);

  const GetUserProfile = async () => {
    try {
      setIsLoading(true);
      const response = await Common.ApiService.getInstance().request(
        "GetApplicationUserProfile"
      );
      const d = response?.data?.[0];
      if (!d) return;

      const formData = {
        ...d,
        gender: d.gender,
        changePassword: false,
        countryId: d.countryId || null,
        stateId: d.stateId || null,
        cityId: d.cityId || null,
        isactive: d.isactive,
        isVerified: d.isVerified,
        dob: d.dob ? d.dob.split("T")[0] : null,
        image: d.image || null,
        phone: d.phoneCode && d.phone ? `${d.phone}` : "",
        phoneNum: d.phone || "",
        phoneCode: d.phoneCode || "+92",
      };

      setImage(formData.image);
      if (d.countryId) getStates(d.countryId);
      if (d.stateId) getCities(d.stateId);

      if (formikRef.current) {
        formikRef.current.setValues(formData);
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const getCities = async (stateId) => {
    try {
      const response = await Common.ApiService.getInstance().request(
        `GetCities?stateId=${stateId}`
      );
      const data = [
        { id: null, name: "Select City" },
        ...(response?.data ?? []),
      ];
      setCity(data);
      return data;
    } catch (error) {
      setCity([{ id: null, name: "Select City" }]);
      return [];
    }
  };

  const getStates = async (countryId) => {
    try {
      const response = await Common.ApiService.getInstance().request(
        `GetStates?countryId=${countryId}`
      );
      const data = [
        { id: null, name: "Select State" },
        ...(response?.data ?? []),
      ];
      setState(data);
      return data;
    } catch (error) {
      setState([{ id: null, name: "Select State" }]);
      return [];
    }
  };

  const getCountries = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetCountries"
    );
    const data = [
      { id: null, name: "Select Country" },
      ...(response?.data ?? []),
    ];
    setCountry(data);
  };

  const handleCountryChange = async (value, formikProps) => {
    if (value) {
      await getStates(value);
      formikProps.setFieldValue("countryId", value);
      formikProps.setFieldValue("stateId", null);
      formikProps.setFieldValue("cityId", null);
      setCity([{ id: null, name: "Select City" }]);
    } else {
      formikProps.setFieldValue("countryId", null);
      formikProps.setFieldValue("stateId", null);
      formikProps.setFieldValue("cityId", null);
      setState([{ id: null, name: "Select State" }]);
      setCity([{ id: null, name: "Select City" }]);
    }
  };

  const handleStateChange = async (value, formikProps) => {
    if (value) {
      await getCities(value);
      formikProps.setFieldValue("stateId", value);
      formikProps.setFieldValue("cityId", null);
    } else {
      formikProps.setFieldValue("stateId", null);
      formikProps.setFieldValue("cityId", null);
      setCity([{ id: null, name: "Select City" }]);
    }
  };

  const _onSubmit = async (d, action) => {
    try {
      let data = {
        ...d,
      };
      if (d.image instanceof File) {
        var image = (
          await Common.Utility.handleFileUpload(
            [d.image],
            ImageFolderEnum.profiles
          )
        )[0].photo;
        d.image = image;
        data.image = image;
      } else if (!d.image) {
        d.image = null;
        data.image = null;
      }

      common.updateUser({
        firstName: data.firstName,
        lastName: data.lastName,
        image: data.image,
      });

      // common.setUser(data);

      const response = await Common.ApiService.getInstance().request(
        "UpdateApplicationUserProfile",
        d,
        "POST"
      );
      action.setSubmitting(false);
      debugger;
      if (response.status === respEnum.Success) {
        Common.SweetAlert.alert(response.message);

        const defaultMenu = global.user?.menus?.find((m) => m.isdefaultview);
        if (defaultMenu) {
          setTimeout(() => {
            navigate(`${defaultMenu.endpoint}`);
          }, 500);
        }
      }
    } catch (err) {
      Common.SweetAlert.alert("Something went wrong!");
      action.setSubmitting(false);
    }
  };

  const Heading = ({ text, icon }) => (
    <div className="flex items-center gap-3 mb-6">
      {icon && <span className="text-2xl">{icon}</span>}
      <h4 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
        {text}
      </h4>
      <div className="flex-1 h-px bg-gradient-to-r from-blue-200 to-purple-200"></div>
    </div>
  );

  const handleImageChange = (file, formikProps) => {
    setImage(file);
    formikProps.setFieldValue("image", file);
  };

  const _renderBasic = () => (
    <Formik
      initialValues={formInitialValues}
      validationSchema={formValidations}
      innerRef={formikRef}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={_onSubmit}
    >
      {(formikProps) => (
        <div className="max-w-7xl mx-auto p-6 space-y-8">
          {/* Header Section */}
          {/* <div className="text-center mb-8">
            <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-2">
              Edit Profile
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Update your personal information and preferences
            </p>
          </div> */}

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
            {/* Left Side - Basic & Status Info */}
            <div className="space-y-6">
              {/* Basic Info Card */}
              <Card className="border-0 shadow-xl bg-white dark:bg-gray-900 rounded-2xl overflow-hidden">
                <div className="bg-gradient-to-r from-blue-50 to-purple-50 dark:from-gray-800 dark:to-gray-700 p-6 border-b">
                  <Heading text="Basic Information" icon="👤" />
                </div>
                <CardContent className="p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <FormikInput
                      formikProps={formikProps}
                      name="firstName"
                      placeholder="Enter First Name"
                      label="First Name"
                    />
                    <FormikInput
                      formikProps={formikProps}
                      name="lastName"
                      placeholder="Enter Last Name"
                      label="Last Name"
                    />
                    <FormikSelect
                      formikProps={formikProps}
                      name="gender"
                      label="Gender"
                      placeholder="Select Gender"
                      data={[
                        { id: null, name: "Select" },
                        { id: 1, name: "Male" },
                        { id: 2, name: "Female" },
                      ]}
                    />
                    <FormikDate
                      formikProps={formikProps}
                      name="dob"
                      type="date"
                      label="Date Of Birth"
                    />
                    <FormikSearchSelect
                      formikProps={formikProps}
                      name="countryId"
                      placeholder="Select Country"
                      label="Country"
                      data={Country}
                      onChange={(val) => handleCountryChange(val, formikProps)}
                    />
                    <FormikSearchSelect
                      formikProps={formikProps}
                      name="stateId"
                      placeholder="Select State"
                      label="State"
                      data={State}
                      onChange={(val) => handleStateChange(val, formikProps)}
                      className={"openTop"}
                    />
                    <FormikSearchSelect
                      formikProps={formikProps}
                      name="cityId"
                      placeholder="Select City"
                      label="City"
                      data={City}
                      className={"openTop"}
                    />
                  </div>
                </CardContent>
              </Card>

              {/* Status Info Card */}
              <Card className="border-0 shadow-xl bg-white dark:bg-gray-900 rounded-2xl overflow-hidden">
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-700 p-6 border-b">
                  <Heading text="Account Status" icon="⚙️" />
                </div>
                <CardContent className="p-6">
                  <div className="space-y-6">
                    {/* Status Indicators */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="flex items-center gap-3 p-4 bg-gray-50 dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700">
                        <div
                          className={`w-3 h-3 rounded-full ${
                            formikProps.values.isactive
                              ? "bg-green-500"
                              : "bg-red-500"
                          }`}
                        ></div>
                        <div>
                          <p className="text-sm text-gray-600 dark:text-gray-400 font-medium">
                            Account Status
                          </p>
                          <p
                            className={`text-lg font-semibold ${
                              formikProps.values.isactive
                                ? "text-green-600 dark:text-green-400"
                                : "text-red-600 dark:text-red-400"
                            }`}
                          >
                            {formikProps.values.isactive
                              ? "🟢 Active"
                              : "🔴 Inactive"}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-center gap-3 p-4 bg-gray-50 dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700">
                        <div
                          className={`w-3 h-3 rounded-full ${
                            formikProps.values.isVerified
                              ? "bg-blue-500"
                              : "bg-yellow-500"
                          }`}
                        ></div>
                        <div>
                          <p className="text-sm text-gray-600 dark:text-gray-400 font-medium">
                            Verification
                          </p>
                          <p
                            className={`text-lg font-semibold ${
                              formikProps.values.isVerified
                                ? "text-blue-600 dark:text-blue-400"
                                : "text-yellow-600 dark:text-yellow-400"
                            }`}
                          >
                            {formikProps.values.isVerified
                              ? "✅ Verified"
                              : "⏳ Pending"}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Change Password Button */}
                    <div className="flex justify-center pt-4">
                      <Button
                        type="button"
                        className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white px-8 py-3 rounded-xl shadow-lg transform transition-all duration-200 hover:scale-105 hover:shadow-xl"
                        onClick={() => {
                          formikProps.setFieldValue("changePassword", true);
                          setShowPasswordDialog(true);
                        }}
                      >
                        🔐 Change Password
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Right Side - Contact & Image */}
            <div className="space-y-6">
              {/* Contact Info Card */}
              <Card className="border-0 shadow-xl bg-white dark:bg-gray-900 rounded-2xl overflow-hidden">
                <div className="bg-gradient-to-r from-indigo-50 to-blue-50 dark:from-gray-800 dark:to-gray-700 p-6 border-b">
                  <Heading text="Contact Information" icon="📧" />
                </div>
                <CardContent className="p-6">
                  <div className="grid grid-cols-1 gap-6">
                    <PhoneInputField formikProps={formikProps} />
                    <FormikInput
                      formikProps={formikProps}
                      name="email"
                      label="Email"
                      disabled
                    />
                  </div>
                </CardContent>
              </Card>

              {/* Profile Image Card */}
              <Card className="border-0 shadow-xl bg-white dark:bg-gray-900 rounded-2xl overflow-hidden">
                <div className="bg-gradient-to-r from-rose-50 to-pink-50 dark:from-gray-800 dark:to-gray-700 p-6 border-b">
                  <Heading text="Profile Image" icon="🖼️" />
                </div>
                <CardContent className="p-6">
                  <div className="space-y-4">
                    <FormikSingleWithMultiUploadInAPage
                      formikProps={formikProps}
                      uploadMainTxt="Upload Profile Image"
                      uploadTxt="Max size 2MB (JPG, PNG)"
                      name="image"
                      maxFileUploadSize={1}
                      value={image}
                      onChange={(file) => handleImageChange(file, formikProps)}
                    />
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-center gap-4 pt-8">
            <Button
              type="button"
              variant="outline"
              className="px-8 py-3 rounded-xl border-2 border-gray-300 hover:border-gray-400 text-gray-700 dark:text-gray-300 font-semibold transition-all duration-200"
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-12 py-3 rounded-xl shadow-lg transform transition-all duration-200 hover:scale-105 hover:shadow-xl font-semibold"
              onClick={(e) => {
                e.preventDefault();
                formikProps.handleSubmit();
              }}
              disabled={formikProps.isSubmitting}
            >
              {formikProps.isSubmitting ? (
                <span className="flex items-center gap-2">
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Updating...
                </span>
              ) : (
                <span className="flex items-center gap-2">
                  ✨ Update Profile
                </span>
              )}
            </Button>
          </div>
        </div>
      )}
    </Formik>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 py-8">
      <div className="container mx-auto px-4">
        {_renderBasic()}
        {showPasswordDialog && (
          <ChangePassword
            open={showPasswordDialog}
            setOpen={setShowPasswordDialog}
            onClose={() => {
              setShowPasswordDialog(false);
              formikRef.current?.setFieldValue("changePassword", false);
            }}
          />
        )}
      </div>
    </div>
  );
}
